import { render, staticRenderFns } from "./ChoiceSex.vue?vue&type=template&id=75a4c472&scoped=true"
import script from "./ChoiceSex.vue?vue&type=script&lang=js"
export * from "./ChoiceSex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a4c472",
  null
  
)

export default component.exports